import styled from 'styled-components';
import { Input, Table } from 'antd';

const { Search } = Input;

export const StyledCodeBlock = styled.p`
  margin: 0;
  padding: 10px;
  border-radius: 5px;
  background-color: #333;
  position: relative;

  pre {
    color: white;
    font-family: monospace;
    font-size: 14px;
  }
`;

export const StyledCodeBlockLoading = styled.div`
  height: 100%;
  width: 100%;
  inset: 0;
  background-color: rgb(0 0 0 / 60%);
  z-index: 20;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledMinifiedSwitch = styled.div`
  line-height: 1;
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 10;
  color: #fff;

  .ant-switch {
    background-color: #000 !important;

    .ant-switch-handle::before {
      background-color: #fff !important;
    }
  }

  .ant-switch.ant-switch-checked {
    filter: invert(1);
  }
`;

export const StyledPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const StyledSearch = styled(Search)<{ width?: number }>`
  width: ${(props) => (props.width ? props.width : 300)}px;
  max-width: 600px;
  position: absolute;
  top: 12px;
  right: 45px;
`;

export const StyledTable = styled(Table)`
  width: 100%;
  margin-top: -5px;
`;
